module.exports = __webpack_public_path__ + "img/card.9cd312b2.jpg";